import React, {
    useState,
    useRef,
    useEffect,
    useMemo,
} from "react";
import { AgGridReact } from "ag-grid-react"; // the AG Grid React Component

import { ErrorBar } from "../../Components/ErrorBar";
import { FtchPlusError, ScenarioUrl_spec, empty_uuid, ftchPlus, getOptions } from "../../App/Account_urls";
import { Box, Paper, Stack } from "@mui/material";
import { moneyFormatter, percent0Formatter, percent1Formatter } from "../../App/GridFormatters";
import { Help_CppGrid } from "../Help/Help_Grids";
import { GoogleAnalyticsEvent } from "../../Components/ga4";
import { GridHeader } from "../../Components/GridHeader";
import { useCallback } from "react";
import { autoSizeStrategy, columnTypes, onHeaderClicked, UpdateColumnGroupIds, UpdateTooltips } from "../../Pages/GridScenario";
import { Arrayify } from "../../Functions/utils";


const cd_Year = {
    headerName: "Year",
    field: "Year",
    sort: "asc",
    width: 75,
    pinned: "left",
    type: "year,rightAligned",

};
const cd_Age = {
    headerName: "Age",
    field: "Age",
    width: 65,
    pinned: "left",
    type: "age,rightAligned",


};
const cd_Cont = {
    headerName: "Basic",
    field: "Cont",
    type: "money,rightAligned",
    valueFormatter: moneyFormatter,

}; const cd_ContFirst = {
    headerName: "1st",
    field: "ContFirst",
    type: "money,rightAligned",
    valueFormatter: moneyFormatter,
    columnGroupShow: "open"


}; const cd_ContSecond = {
    headerName: "2nd",
    field: "ContSecond",
    type: "money,rightAligned",
    valueFormatter: moneyFormatter,
    columnGroupShow: "open"


}; const cd_UPE = {
    headerName: "UPE",
    field: "UPE",
    type: "money,rightAligned",
    valueFormatter: moneyFormatter,
};
const cd_EarnFirst = {
    headerName: "1st",
    field: "UPE",
    type: "money,rightAligned",
    valueFormatter: moneyFormatter,
};
const cd_EarnSecond = {
    headerName: "AUPE",
    field: "AUPE",
    type: "money,rightAligned",
    valueFormatter: moneyFormatter,
    columnGroupShow: "open"


};
const cd_PercentYearly = {
    headerName: "% UPE",
    field: "PercentUPE",
    type: "percent,rightAligned",
    valueFormatter: percent0Formatter,
};
const cd_AYMPECalc = {
    headerName: "AYMPE:Est",
    field: "AYMPE_Calc",
    type: "money,rightAligned",
    valueFormatter: moneyFormatter,
    columnGroupShow: "open"
};

const cd_YMPE = {
    headerName: "YMPE",
    field: "YMPE",
    type: "money,rightAligned",
    valueFormatter: moneyFormatter,
    columnGroupShow: "open"
};
const cd_YAMPE = {
    headerName: "YAMPE",
    field: "YAMPE",
    type: "money,rightAligned",
    valueFormatter: moneyFormatter,
    columnGroupShow: "open"
};

const cd_AYMPE = {
    headerName: "AYMPE",
    field: "AYMPE",
    type: "money,rightAligned",
    valueFormatter: moneyFormatter,
    columnGroupShow: "open"
};
const cd_AYAMPE = {
    headerName: "AYAMPE",
    field: "AYAMPE",
    type: "money,rightAligned",
    valueFormatter: moneyFormatter,
    columnGroupShow: "open"
};

const cd_APE = {
    headerName: "APE",
    field: "APE",
    type: "money,rightAligned",
    valueFormatter: moneyFormatter,

}; const cd_TAPE = {
    headerName: "TAPE",
    field: "TAPE",
    type: "money,rightAligned",
    valueFormatter: moneyFormatter,
    width: 140,
    columnGroupShow: "open"
};

const cd_Months = {
    headerName: "Months",
    field: "Months",
    columnGroupShow: "open",
    type: "age,rightAligned",
};
const cd_Dropout = {
    headerName: "Drop",
    field: "Dropout",
    columnGroupShow: "open",
    width: 70,

}; const cd_NCM = {
    headerName: "NCM",
    field: "NCM",
    columnGroupShow: "open",
    type: "age,rightAligned",
}; const cd_NDM = {
    headerName: "NDM",
    field: "NDM",
    columnGroupShow: "open",
    type: "age,rightAligned",

}; const cd_PDM = {
    headerName: "PDM",
    field: "PDM",
    columnGroupShow: "open",
    type: "age,rightAligned",
}; const cd_Monthly = {
    headerName: "Monthly",
    field: "BenMonthly",
    type: "money,rightAligned",
    valueFormatter: moneyFormatter,
    columnGroupShow: "open"


}; const cd_Yearly = {
    headerName: "Yearly",
    field: "BenYearly",
    type: "money,rightAligned",
    valueFormatter: moneyFormatter,


}; const cd_Percent = {
    headerName: "% Basic",
    field: "BenPercent",
    type: "percent,rightAligned",
    valueFormatter: percent1Formatter,
    columnGroupShow: "open"

};



const cd_APEDropout = {
    headerName: "Drop",
    field: "APEDropout",
    type: "money,rightAligned",
    valueFormatter: moneyFormatter,
    columnGroupShow: "open"
}; const cd_FAAPE = {
    headerName: "FAAPE",
    field: "FAAPE",
    type: "money,rightAligned",
    valueFormatter: moneyFormatter,
}; const cd_FTAAPE = {
    headerName: "FTAAPE",
    field: "FTAAPE",
    width: 140,
    columnGroupShow: "open",
    type: "money,rightAligned",
    valueFormatter: moneyFormatter,
}; const cd_FAMPE = {
    headerName: "C.FAMPE",
    field: "FAMPE",
    type: "money,rightAligned",
    valueFormatter: moneyFormatter,
    columnGroupShow: "open"

}; const cd_Firstmonth = {
    headerName: "C.Months",
    field: "FirstMonths",
    columnGroupShow: "open"
}; const cd_FirstMonthly = {
    headerName: "Monthly",
    field: "FirstMonthly",
    type: "money,rightAligned",
    valueFormatter: moneyFormatter,
    columnGroupShow: "open"

}; const cd_FirstDropout = {
    headerName: "Drop",
    field: "FirstDropout",
    columnGroupShow: "open",
    type: "age,"

}; const cd_BenFirstMonthly = {
    headerName: "Monthly",
    field: "BenFirstMonthly",
    type: "money,rightAligned",
    valueFormatter: moneyFormatter,

    columnGroupShow: "open"
}; const cd_BenFirstYearly = {
    headerName: "Yearly",
    field: "BenFirstYearly",
    type: "money,rightAligned",
    valueFormatter: moneyFormatter,
}; const cd_BenFirstPercent = {
    headerName: "%",
    field: "BenFirstPercent",
    type: "percent,rightAligned",
    valueFormatter: percent0Formatter,
    columnGroupShow: "open"
};

const cd_SAAPE = {
    headerName: "SAAPE",
    field: "SAAPE",
    type: "money,rightAligned",
    valueFormatter: moneyFormatter,
};
const cd_STAAPE = {
    headerName: "STAAPE",
    field: "STAAPE",
    width: 140,
    type: "money,rightAligned",
    valueFormatter: moneyFormatter,
    columnGroupShow: "open"

};
const cd_SAMPE = {
    headerName: "C.SAMPE",
    field: "SAMPE",
    type: "money,rightAligned",
    valueFormatter: moneyFormatter,
    columnGroupShow: "open"

}; const cd_Secondmonth = {
    headerName: "C.Months",
    field: "SecondMonths",
    columnGroupShow: "open"

}; const cd_SecondMonthly = {
    headerName: "Monthly",
    field: "SecondMonthly",
    type: "money,rightAligned",
    valueFormatter: moneyFormatter,
    columnGroupShow: "open"
}; const cd_SecondDropout = {
    headerName: "Drop",
    field: "SecondDropout",
    type: "age,rightAligned",
    columnGroupShow: "open"
}; const cd_BenSecondMonthly = {
    headerName: "Monthly",
    field: "BenSecondMonthly",
    type: "money,rightAligned",
    valueFormatter: moneyFormatter,
    columnGroupShow: "open"

}; const cd_BenSecondYearly = {
    headerName: "Yearly",
    field: "BenSecondYearly",
    type: "money,rightAligned",
    valueFormatter: moneyFormatter,
}; const cd_BenSecondPercent = {
    headerName: "%",
    field: "BenSecondPercent",
    type: "percent,rightAligned",
    valueFormatter: percent0Formatter,
    columnGroupShow: "open"

};

const cd_Benefit = {
    headerName: "Benefit",
    field: "Benefit",
    type: "money,rightAligned",
    valueFormatter: moneyFormatter,
};
const cd_BenefitScaled = {
    headerName: "Scaled",
    field: "BenefitScaled",
    type: "money,rightAligned",
    valueFormatter: moneyFormatter,

};
const cd_Survivor = {
    headerName: "Survivor",
    field: "Survivor",
    type: "money,rightAligned",
    valueFormatter: moneyFormatter,

}; const cd_Total = {
    headerName: "Payment",
    field: "Total",
    type: "money,rightAligned",
    valueFormatter: moneyFormatter,

};

export const cpp_columnDefs = [
    cd_Year,
    cd_Age,
    {
        headerName: "Contributions",
        groupId: "Contributions",
        children: [cd_Cont, cd_ContFirst, cd_ContSecond],
    },
    {
        headerName: "Pensionable Earnings",
        groupId: "Pensionable Earnings",
        children: [cd_UPE, cd_EarnSecond],
    },
    {
        headerName: "Calculations",
        groupId: "Calculations",
        children: [
            {
                headerName: "Basic (25% replacement)",
                groupId: "Calculations:Basic",
                children: [cd_PercentYearly, cd_AYMPECalc, cd_APE, cd_TAPE, cd_Months, cd_Dropout, cd_NDM, cd_PDM],
            },
            {
                headerName: "1st (25 to 33% replacement)",
                groupId: "Calculations:first",
                children: [/*cd_APEDropout,*/ cd_FAAPE, cd_FTAAPE, cd_FAMPE/*, cd_Firstmonth,*/ /*cd_FirstDropout*/],

            },
            {
                headerName: "2nd  (larger (14%) more income coverage)",
                groupId: "Calculations:second",
                children: [cd_SAAPE, cd_STAAPE, cd_SAMPE/*, cd_Secondmonth,cd_SecondDropout*/],
            },
        ],
    },
    {
        headerName: "Benefits",
        groupId: "Benefits",
        children: [
            {
                headerName: "Basic",
                groupId: "Benefits:Basic",
                children: [cd_Monthly, cd_Yearly, cd_Percent],
            },
            {
                headerName: "1st",
                groupId: "Benefits:1st",
                children: [cd_BenFirstMonthly, cd_BenFirstYearly/*, cd_BenFirstPercent*/],
            },
            {
                headerName: "2nd",
                groupId: "Benefits:2nd",
                children: [cd_BenSecondMonthly, cd_BenSecondYearly/*, cd_BenSecondPercent*/],
            },
            {
                headerName: "Personal Total",
                groupId: "Benefits:persTot",
                children: [cd_Benefit, cd_BenefitScaled],
            },
            {
                headerName: "Survivor",
                groupId: "Benefits:Survivor",
                children: [cd_Survivor],
            },
            {
                headerName: "Total",
                groupId: "Benefits:Total",
                children: [cd_Total],
            },
        ],
    }
];







const CppGrid = ({
    clientJson,
    scen_uuid,
    scen_name,
    width,
    height,
    onClose,
    onExpand,
    name = "CPP*"
}) => {
    const gridRef = useRef(null);
    const clientData = useRef(null);
    const topRow = useRef(null);
    const [client, setClient] = useState("");
    const [clients, setClients] = useState([]);
    const [dataSets, setDataSets] = useState([]);
    const [dataSet, setDataSet] = useState("");
    const [rowData, setRowData] = useState();
    const [topRowData, setTopRowData] = useState([]);
    const [bottomRowData, setBottomRowData] = useState([]);
    const [showSums, setShowSums] = useState(false);
    const [loading, setLoading] = useState(true)


    const [errmsg, setErrmsg] = useState("")

    const defaultColDef = useMemo(() => ({
        field: "",
        sortable: false,
        resizable: true,
        suppressMovable: true,
        editable: false,
        width: 100,
        type: "rightAligned",
    }));







    const getData = async () => {
        setLoading(true)
        console.log(clientJson);
        if (scen_uuid && scen_uuid !== empty_uuid) {
            console.log(clientJson.Scenario);
            GoogleAnalyticsEvent("grid", "view", "cpp", { action: "view", type: "cpp" })
            var url = ScenarioUrl_spec(clientJson, scen_uuid, "cpp", "");

            ftchPlus(url, getOptions)
                .then((json) => {
                    console.log(json);
                    clientData.current = json.ClientData;
                    topRow.current = json.TopRow
                    setClients(json.Clients);
                    setDataSets(json.DataSets);
                    const cl = json.Clients[0];
                    setClient(cl);
                    const ds = json.DataSets[0];
                    setDataSet(ds);
                    Update(cl, ds);
                    setLoading(false)
                })
                .catch((error) => {
                    console.log(error.message);
                    setErrmsg(error.message)
                    FtchPlusError(error)
                    setLoading(false)
                });
        }
    };

    const btnClientChanged = (value) => {
        setClient(value);
        Update(value, dataSet);
    };

    const btnDataSetChanged = (value) => {
        setDataSet(value);
        Update(client, value);
    };

    // load data from sever
    useEffect(() => {
        setErrmsg("")
        getData();

    }, [clientJson]);

    const onShowSums = (n, v) => {
        setShowSums(v)
        setTopRowData([])
        setBottomRowData([])

        updateSums(v, client, dataSet)
    }

    const updateSums = (show, cl, ds) => {
        if (show) {
            if (topRow.current) {
                topRow.current[cl][ds][0].Year = "Aggregate"
                topRow.current[cl][ds][0].Age = ""
                setTopRowData(Arrayify(topRow.current[cl][ds]));
            }
        }
    }

    const displayShowSums = () => {
        if (topRow.current) {
            return onShowSums
        }
        return null
    }


    const Update = (cl, ds) => {

        //setColumnDefs(clientData.current[cl][ds].Headers);
        // let headers = UpdateColumnGroupIds(clientData.current[cl][ds].Headers, "")
        // headers = UpdateTooltips(headers)
        // setColumnDefs(headers);

        setRowData(clientData.current[cl][ds]);
        updateSums(showSums, cl, ds)

    };
    const onRowDataUpdated = useCallback((event) => {
        event.api.autoSizeAllColumns();
    }, []);

    const gridRefFn = () => {
        return gridRef
    }

    return (
        <Paper>
            <Box sx={{ p: 4 }}>
                <Stack spacing={4}>
                    <GridHeader
                        name={name + " Calculations"}
                        scenName={scen_name}
                        clientJson={clientJson}
                        clients={clients}
                        client={client}
                        onClientChange={btnClientChanged}
                        dataSets={dataSets}
                        dataSet={dataSet}
                        onDataSetChange={btnDataSetChanged}
                        onExpand={onExpand}
                        onClose={onClose}
                        gridRefFn={gridRefFn}
                        showSums={showSums}
                        onShowSums={displayShowSums()}
                    />

                    <div
                        className="ag-theme-alpine"
                        style={{
                            width: "100%", height: height
                        }}
                    >
                        <AgGridReact
                            ref={gridRef}
                            rowData={rowData} // Row Data for Rows
                            pinnedTopRowData={topRowData}
                            pinnedBottomRowData={bottomRowData}
                            rowHeight={32}
                            columnDefs={cpp_columnDefs} // Column Defs for Columns
                            defaultColDef={defaultColDef} // Default Column Properties
                            columnTypes={columnTypes}
                            tooltipShowDelay={1200}
                            // animateRows={true} // Optional - set to 'true' to have rows animate when sorted
                            //suppressCellSelection={true}
                            //rowSelection= {mode="singleRow"}
                            onRowDataUpdated={onRowDataUpdated}
                            autoSizeStrategy={autoSizeStrategy}
                            autoSizePadding={8}
                            onColumnHeaderClicked={onHeaderClicked}
                            loading={loading}


                        // onCellClicked={cellClickedListener} // Optional - registering for Grid Event
                        // overlayNoRowsTemplate={none}
                        />
                    </div>
                    <Help_CppGrid />
                    <ErrorBar error={errmsg} />
                </Stack>
            </Box>
        </Paper >
    );
};

export default CppGrid;
